export default __webpack_public_path__ + "static/media/footer-desktop-circle.ec5737d6.png";